var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TransactionListTemplate',{ref:"supplier-invoiced-list",attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"persistenceKey":'supplier-invoiced-list',"gcPopupConfig":_vm.gcPopupConfig,"setLoading":_vm.setLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }